var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUndoEnabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 5.09319V0.959021C11 0.784854 10.9083 0.629021 10.7525 0.555687C10.6058 0.473187 10.4225 0.482354 10.2758 0.583187L0.1925 7.45819C0.0733333 7.54069 0 7.67819 0 7.83402C0 7.98985 0.0733333 8.12735 0.201667 8.20985L10.285 15.0849C10.4225 15.1765 10.6058 15.1949 10.7617 15.1124C10.9083 15.0299 11 14.874 11 14.709V10.5932C16.1333 10.9049 21.0467 16.2582 21.0833 17.4499C21.0833 17.4499 21.0833 17.4499 21.0833 17.459C21.0833 17.4682 21.0833 17.459 21.0833 17.4682C21.1017 17.7065 21.2942 17.899 21.5417 17.899H21.5508C21.7983 17.8899 22 17.6882 22 17.4315C21.9083 12.3624 18.04 5.38652 11 5.09319Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndoEnabled);
export default __webpack_public_path__ + "static/media/undo-enabled.7d24a1b57453b0a5b0376edc63596224.svg";
export { ForwardRef as ReactComponent };